<template>
  <div class="main">
        <div class="content" id="mount-point">
          <div class="money-box">
            <span v-if="payDetail!=null && parseFloat(payDetail.SFXX[0]['GRSFBZ']) == 0">
                <div v-if="parseFloat(payDetail.SFXX[0]['YFJE']) <= 0">无需支付</div>
                <span v-if="parseFloat(payDetail.SFXX[0]['YFJE']) > 0">
                  &yen; <span class="topmoney">{{payDetail.SFXX[0]['YFJE']}}</span> 元
                  <br/> 需支付
                  </span>
            </span>
              <span  v-if="payDetail!=null && parseFloat(payDetail.SFXX[0]['GRSFBZ']) != 0">已支付
                <span class="topmoney">{{payDetail.SFXX[0]['YFJE']}}</span> 元
              </span>
          </div>
          <div class="van-doc-demo-block">
            <van-cell-group v-if="payDetail!=null">
              <van-cell title="姓 名" :value="payDetail.SFXX[0]['XM']" value-class="name"/>
              <van-cell title="体检编号" :value="payDetail.SFXX[0]['TJBH']" />
              <van-cell title="体检次数" :value="payDetail.SFXX[0]['TJCS']" />
              <van-cell title="体检金额" :value="payDetail.SFXX[0]['YJ']" />
              <van-cell title="单位配额" :value="payDetail.SFXX[0]['DWZFJE']" />
              <van-cell title="个人支付" :value="payDetail.SFXX[0]['YFJE']" value-class="money"/>
            </van-cell-group>
          </div>
          <div class="van-doc-demo-block" v-if="VUE_APP_PAY_DETAIL_ITEMSHOW">
            <h2 class="van-doc-demo-block__title">项目明细</h2>
            <van-cell-group v-if="payDetail!=null">
              <van-cell v-for="(item,index) in payDetail.XMList" :key="index" :title="item.XMMC" :value="item.XMDJ" />
            </van-cell-group>
          </div>
        </div>
      <div class="footer">
        <van-button v-if="payDetail!=null" size="large" block type="primary" :disabled="parseFloat(payDetail.SFXX[0]['YFJE']) <= 0" @click="pay()">
          <van-icon :name="icon_wechat_pay"  style="vertical-align: middle;margin-right: .5em;"/>立 即 付 款</van-button>
      </div>
  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm.js'
import {getPayDetailBySerialno,toIcbcPay} from '@/api/module/index'
import {encrypt} from "@/assets/utils/cryptoUtil";
import {Dialog, Toast} from "vant";
import {transactions} from "@/api/module/auth";
import {loginByOpenid} from "@/api/module/user";
export default {
  name: "index",
  data() {
    return {
      payDetail:null,
      icon_wechat_pay:require("@/assets/images/WechatPayWhite.svg"),
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_PAY_DETAIL_ITEMSHOW:window.g.VUE_APP_PAY_DETAIL_ITEMSHOW,
      VUE_APP_GET_OPENID_TYPE:window.g.VUE_APP_GET_OPENID_TYPE,
      VUE_APP_PAY_TYPE: window.g.VUE_APP_PAY_TYPE,
      VUE_APP_GET_OPENID_PARAM_NAME:window.g.VUE_APP_GET_OPENID_PARAM_NAME,
      VUE_APP_GET_OPENID_URL:window.g.VUE_APP_GET_OPENID_URL,
      selfAmount:0,
    };
  },
  created() {
    this.getPayDetailBySerialno()
  },
  methods: {
    getPayDetailBySerialno(){
      let params = {
        serialno:encrypt(this.$route.query.serialno)
      }
      getPayDetailBySerialno(params).then(res =>{
        if (res.code == 200) {
          if(res.data != null){
            this.payDetail = res.data
            this.selfAmount = res.data.SFXX[0].YFJE
          }
          else{
            Toast("未查询到数据")
          }
        }
      })
    },
    pay(){
      let orderDate = this.formatDateTime(new Date())
      //结束时间要比开始时间晚5分钟
      let endTime = this.formatDateTime(new Date(new Date().getTime() + 1 * 5 * 60 * 1000))
      switch (this.VUE_APP_PAY_TYPE){
        case "2":{
          this.jsApiPay()
          break;
        }
        default:{
          //默认龙川家对接银行的工行支付
          let params = {
            orderNo:this.payDetail.SFXX[0]['TJBH'],
            orderDate:orderDate,
            endTime:endTime,
            orderAmount:this.payDetail.SFXX[0].YFJE*100
          }
          toIcbcPay(params).then(res =>{
            if (res.code == 200) {
              //第一种方式：在苹果手机上点击没反应
              //后端返回的html字符串带script标签
              //注意点：不能在当前页面追加任何元素例如原生js：innerHtml、appendChiled等等；Vue原生v-html也不可以因为其只能渲染html标签，script不能够识别。
              //需要重新创建一个空白Vue组件，用router进行传参，传参方式（新窗口打开）
              // let routeData = this.$router.resolve({ path: 'recharge', query: { htmls: res.data}});
              // console.log(routeData)
              // window.open(routeData.href, '_blank');
              //第二种方式：
              this.$router.push({path: "/recharge", query: {htmls: res.data}})
            }
          })
        }
      }
    },
    jsApiPay() {
      if (this.VUE_APP_ISWECHAT == "1") {
        if("home_url_param_openId" == this.VUE_APP_GET_OPENID_TYPE){
            this.openid = this.getUrlParam(this.VUE_APP_GET_OPENID_PARAM_NAME)
          console.log("openid:" + this.openid)
            if (this.openid == null || this.openid != '') {
              window.location.href = 'http://oauth.jin1.com.cn/medicaljinyi/externalOauth?nextPage=http://tj.czsfyyk.cn/#/payDetail?serialno='+this.$route.query.serialno+'&hospitalCode=czsfybjy'
            return
            }
        }
        else{
          let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
          this.openid = userinfo.openid
        }
      }
      var vm = this
      if (this.openid == '') {
        alert("缺少openid")
        return;
      }
      let total = parseFloat(this.selfAmount)*100
      let params = {
        type: 'jsapi',//支付类型
        openid: this.openid,//公众号id
        total: total,//订单金额
        attach:this.$route.query.serialno,
        description: '体检费-扫码收费',//商品描述信息
      }
      transactions(params).then(res => {
        let data = {
          appId: res.signMap.appId,//公众号id，必传
          nonceStr: res.signMap.nonceStr,//随机串，必传
          timeStamp: res.signMap.timeStamp,//时间戳，必传
          package: "prepay_id=" + res.prepay_id,//必传
          signType: res.signMap.signType,//微信签名方式
          paySign: res.signMap.paySign,//微信签名
        }
        // 下面是解决WeixinJSBridge is not defined 报错的方法
        if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            setTimeout(function () {
              document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
            }, 1000)

          } else if (document.attachEvent) {
            setTimeout(function () {
              document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
              document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
            }, 1000)
          }
        } else {
          console.log('准备调用微信支付')
          setTimeout(function () {
            vm.onBridgeReady(data)
          }, 1000)
        }
      }).catch(err => {
        Dialog.alert({
          message: "统一下单返回出错：" + err
        }).then(() => {

        })
      })
    },
    onBridgeReady(data) {
      console.log('调用微信支付WeixinJSBridge')
      console.log('参数', data)
      var vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': data.timeStamp, // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.package, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              Dialog.alert({
                message: '支付成功'
              }).then(() => {
                //支付成功后更新订单状态
                vm.$router.push('/orders')
              })
            } else {
              Dialog.alert({
                message: res.err_msg === 'get_brand_wcpay_request:cancel'?"已取消支付":"支付失败" + res.err_msg
              }).then(() => {
                vm.$router.push('/orders')
              })
            }
          }
      )
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    formatDateTime(date) {
      if (date == "" || !date) {
        return "";
      }
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? ('0' + minute) : minute;
      var second = date.getSeconds();
      second = second < 10 ? ('0' + second) : second;
      return y + m + d + h + minute + second;
    },
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
}
.content,.footer{
  width: 100%;
}
.footer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}
.content{
  flex:1;
}
.money-box {
  padding:3em 0;
  text-align: center;
  color: #ccc;
  background: url("~@/assets/images/money-box.png") center 0 no-repeat;
}

.money-box>.money {
  font-weight: 700;
  font-size: 34px;
  color: #fff;
  padding: 0 5px;
}
.money{
  color: #ff6c6c;
  font-size: 1.2em;
}
.topmoney{
  color: #ff6c6c;
  font-size: 1.8em;
}
.van-doc-demo-block__title{
  padding-left: .5em;
  line-height: 2em;
  font-weight: bold;
  font-size: 1.2em;
}
.name{
  font-size: 1.4em;
}
</style>
